import React from 'react'

interface FieldHintProps {
	children: React.ReactNode
	/** Extra classes, e.g. to drop the default top margin in a flex row. */
	className?: string
	/** Associates the hint with its control via aria-describedby. */
	id?: string
}

/**
 * Descriptive helper text shown beneath a form control.
 *
 * Single source of truth for hint styling: `Input`, `Select` and `Textarea` all render
 * their `hint` prop through this, and hand-rolled controls that can't use those
 * primitives (e.g. the grouped region/sub-region pickers, which need `<optgroup>`)
 * should use it directly rather than re-declaring the classes.
 *
 * `neutral-550` sits one step lighter than the `neutral-600` used for labels' sibling
 * text, so a hint reads as secondary to its label. Change the token, not this class,
 * to restyle every hint at once.
 */
export const FieldHint: React.FC<FieldHintProps> = ({ children, className = '', id }) => (
	<p id={id} className={`text-neutral-550 text-sm mt-1 ${className}`}>
		{children}
	</p>
)

export default FieldHint
